// src/components/TickerBar.jsx
import './TickerBar.css';

const TickerBar = () => {
  // Mock data – replace later with API data
  const stateFees = [
    { state: 'CA', fee: 50000 },
    { state: 'NY', fee: 75000 },
    { state: 'FL', fee: 35000 },
    { state: 'TX', fee: 28000 },
    { state: 'IL', fee: 42000 },
    { state: 'MO', fee: 30000 },
    { state: 'AZ', fee: 25000 },
    { state: 'GA', fee: 32000 },
  ];

  return (
    <div className="ticker-wrapper">
      <div className="ticker-rail">
        {/* First full loop */}
        {stateFees.map((item, index) => (
          <div className="ticker-item" key={`a-${index}`}>
            <span className="ticker-state">{item.state}</span>
            <span className="ticker-fee">
              ${item.fee.toLocaleString()}
            </span>
          </div>
        ))}

        {/* Second full loop (for seamless scroll) */}
        {stateFees.map((item, index) => (
          <div className="ticker-item" key={`b-${index}`}>
            <span className="ticker-state">{item.state}</span>
            <span className="ticker-fee">
              ${item.fee.toLocaleString()}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TickerBar;
